import { render } from "./TahunSemasa.vue?vue&type=template&id=7990afd4"
import script from "./TahunSemasa.vue?vue&type=script&lang=js"
export * from "./TahunSemasa.vue?vue&type=script&lang=js"

import "./TahunSemasa.vue?vue&type=style&index=0&id=7990afd4&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__